// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jc-0";
export var assigneeDetails = "_jc-1";
export var assigneeInfo = "_jc-2";
export var dropdownContainer = "_jc-4";
export var dropdownImage = "_jc-5";
export var editAssigneeInfo = "_jc-3";
export var editAssigneeModalContainer = "_jc-6";
export var hidden = "_jc-8";
export var input = "_jc-7";